"use client";

import { ModalContainer, MODAL_IDS } from "@wtc/ui";
import { SaveAttachmentsToGoogleDriveModal } from "./SaveAttachmentsToGoogleDriveModal";
import type { Message } from "@/lib/core/crm/types";

interface SaveAttachmentsModalData {
  message: Message;
}

export function SaveAttachmentsToGoogleDriveModalContainer() {
  return (
    <ModalContainer<SaveAttachmentsModalData> 
      modalId={MODAL_IDS.messages.saveAttachmentsToGoogleDrive}
    >
      {({ isOpen, data, onClose }) => (
        <SaveAttachmentsToGoogleDriveModal
          open={isOpen}
          onOpenChange={onClose}
          message={data?.message!}
          globalModalId={MODAL_IDS.messages.saveAttachmentsToGoogleDrive}
        />
      )}
    </ModalContainer>
  );
}
